<template>
  <div class="header" :style="{backgroundColor:isInModule?'#ff3c00':'#fff'}">
    <div>
      <img :src="hover.topImage" v-if="isInModule">
      <img :src="normal.topImage" v-else>
    </div>
    <div>
      <img :src="hover.middleImage" v-if="isInModule">
      <img :src="normal.middleImage" v-else>
    </div>
    <div>
      <img :src="hover.bottomImage" v-if="isInModule">
      <img :src="normal.bottomImage" v-else>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ModuleNav',
    props: ['normal', 'hover', 'isInModule'],
  };
</script>

<style scoped lang="less">
  .header {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 18vh;
    height: 86vh;
    margin: 7vh 1vh;
    border-left: 1px solid #000;
    border-right: 1px solid #000;
    transition: background-color .3s;

    > div {
      &:first-of-type {
        margin-top: 2vh;

        img {
          width: 12vh
        }
      }

      &:nth-of-type(2) img {
        width: 9vh
      }

      &:last-of-type {
        margin-bottom: 2vh;

        img {
          width: 9.5vh
        }
      }
    }
  }
</style>
